import { Component, OnInit, Input } from '@angular/core';
import { DataService, MIN_CHAR_SEARCH_LENGTH, AuthService, DateUtility } from '../shared';

@Component({
  selector: 'app-header-nav',
  templateUrl: './header-nav.component.html',
  styleUrls: ['./header-nav.component.scss']
})
export class HeaderNavComponent implements OnInit {
  @Input() pageInfo;
  constructor(private dataService:DataService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/header-nav/header-nav.component.ts